import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';
import { ControlUIType, ProductControlSingle } from 'editor/src/store/variants/types';

import selectSingleOptionOperation from './selectSingleOptionOperation';

/**
 * GAPI-43148 — host-driven print-technology switch (DTG <-> DTF). Reuses the exact
 * path the in-editor "Print technic" radio uses (`selectSingleOptionOperation` on the
 * Technology control), so variation groups, designs and prices update identically.
 * Used when the customer accepts the dashboard's DTF-vs-DTG suggestion.
 *
 * No-op (returns false) in multi-tech mode or when the control/option isn't found —
 * the host keeps the current technology in that case.
 */
const applyPrintTechnologyOperation =
  (technology: string) =>
  (dispatch: ThunkDispatch, getState: () => RootState): boolean => {
    const state = getState();

    if (state.app.multiTechMode) {
      return false;
    }

    const control = state.variants.product?.productControls?.find(
      (productControl): productControl is ProductControlSingle =>
        productControl.type === 'single' && productControl.uiType === ControlUIType.Technology,
    );

    const option = control?.options.find(
      (controlOption) => controlOption.value?.toLowerCase() === technology.toLowerCase(),
    );

    if (!control || !option) {
      return false;
    }

    dispatch(selectSingleOptionOperation(control, option));
    return true;
  };

export default applyPrintTechnologyOperation;
